import { listReport } from './WashingHistoryByDay/WashingHistory.i18n.ja'

export const washingHistory = {
  listReport,
}
